import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "./translations/en.json";
import es from "./translations/es.json";
import pt from "./translations/pt.json";

export const SUPPORTED_LANGUAGES = ["pt", "en", "es"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

const HTML_LANG: Record<SupportedLanguage, string> = { pt: "pt-BR", en: "en", es: "es" };

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "pt",
    supportedLngs: [...SUPPORTED_LANGUAGES],
    // "pt-BR" → "pt", "en-US" → "en"
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lang",
      lookupLocalStorage: "mbfloripa.lang",
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
    resources: {
      en: { translation: en },
      es: { translation: es },
      pt: { translation: pt },
    },
  });

/** Idioma atual normalizado para um dos suportados. */
export const currentLanguage = (): SupportedLanguage => {
  const base = (i18n.resolvedLanguage || i18n.language || "pt").split("-")[0];
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(base)
    ? (base as SupportedLanguage)
    : "pt";
};

const syncHtmlLang = () => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = HTML_LANG[currentLanguage()];
  }
};

i18n.on("initialized", syncHtmlLang);
i18n.on("languageChanged", syncHtmlLang);
syncHtmlLang();

export default i18n;
